export default __webpack_public_path__ + "static/icon-high-rise-3f09daeba6b39396a92d613fd38f3d1d.webp";